import React from "react";
import styles from "./choose-button.module.css";

const ChooseButton = (props) => {
  return (
    <button className={props.isSelected ? `${styles.button} ${styles.selected}`: styles.button} onClick={props.onClick} disabled={props.disabled}>
      {props.children}
      <span className={styles.icon}>{props.icon}</span>
    </button>
  );
}

export { ChooseButton };